import React, { useState, useEffect, Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import './App.css';
import { ProductProvider } from "./pages/pagesCardapio/ProductContext";
import { AppProvider, useAppContext } from "./api/AppContext";
import NavBar from "./components/NavBar";
import { NotificationProvider } from './contexts/NotificationContext';

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const isChunkError = /Loading chunk|ChunkLoadError|Importing a module script failed/i.test(String(error?.message || error));
    if (isChunkError && !sessionStorage.getItem('chunk-reload-attempted')) {
      sessionStorage.setItem('chunk-reload-attempted', '1');
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100dvh', backgroundColor: '#F0F3FF', fontFamily: 'Montserrat', textAlign: 'center', padding: '24px' }}>
          <div style={{ fontSize: '16px', color: '#1A3B7D', fontWeight: 'bold', marginBottom: '12px' }}>
            Ops, algo deu errado.
          </div>
          <div style={{ fontSize: '14px', color: '#666', marginBottom: '16px' }}>
            Toque para tentar carregar novamente.
          </div>
          <button
            onClick={() => { sessionStorage.removeItem('chunk-reload-attempted'); window.location.reload(); }}
            style={{ backgroundColor: '#2a89ff', color: '#fff', border: 'none', borderRadius: '10px', padding: '12px 32px', fontSize: '14px', cursor: 'pointer' }}
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const [isDesktop, setIsDesktop] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const check = () => {
      const desktop = window.innerWidth >= 768;
      setIsDesktop(desktop);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  //console.log('[App] mounted:', mounted, 'isDesktop:', isDesktop);

  if (!mounted) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100vw', height: '100dvh', backgroundColor: '#F0F3FF' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '4px solid #e0e0e0', borderTopColor: '#1A3B7D', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 16px' }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          <span style={{ color: '#888', fontSize: '14px', fontFamily: 'Montserrat' }}>Carregando...</span>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <NotificationProvider>
        <AppProvider>
          <ProductProvider>
            <Router>
              <div className={`app-container ${isDesktop ? 'desktop-layout' : 'mobile-layout'}`}>
                <AuthAwareNavBar />
                <main className="main-content">
                  <AppRoutes />
                </main>
              </div>
            </Router>
          </ProductProvider>
        </AppProvider>
      </NotificationProvider>
    </ErrorBoundary>
  );
}

function AuthAwareNavBar() {
  const { isAuthenticated } = useAppContext();
  //console.log('[NavBar] isAuthenticated:', isAuthenticated);
  return isAuthenticated ? <NavBar /> : null;
}

export default App;